import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=74284917&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=js&"
export * from "./Record.vue?vue&type=script&lang=js&"
import style0 from "./Record.vue?vue&type=style&index=0&id=74284917&scoped=true&lang=css&"
import style1 from "./Record.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74284917",
  null
  
)

component.options.__file = "Record.vue"
export default component.exports